import { db, explore } from "../../../service/API";
import store from "../../store/store";

// Tools
const ft = require("../Tools/FileTools");

/**
 * This object has for sole purpose to create the schedule file which will be sent to the player.
 */
export class ScheduleFileMaker {
  constructor() {
    //
  }

  init(scheduleManager, playerName, playerLicense, userData, preview = false) {
    return new Promise((resolve, reject) => {
      this.scheduleManager = scheduleManager;
      this.playerName = playerName;
      this.userData = userData;

      this.playerLicense = playerLicense;
      this.preview = preview;
      this.previewPath = "./temp/" + userData.socId + "/" + userData.userId + "/readingPreview/";
      this.userPath = "./temp/" + userData.socId + "/" + userData.userId + "/";
      this.folderName = this.playerName + "_" + this.userData.socId;
      this.compiledPath = this.userPath + "compiled/" + this.folderName + ".zip";
      this.readingPath = this.userPath + "readingDirectory/projects/";
      this.compilingPath = this.userPath + "compilingProject/" + this.folderName;
      this.projectsPath = this.compilingPath + "/projects/";

      this.createScheduleSavePath()
        .then(() => {
          return resolve(this);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  /**
   * Create a directory but check if exist before to prevent status 500 for already exist
   * @param { String } dirpath
   * @returns Promise
   */
  createDir(dirpath) {
    return new Promise((resolve, reject) => {
      ft.exists(dirpath)
        .then((response) => {
          if (!response) {
            ft.createDir(dirpath)
              .then(() => {
                return resolve();
              })
              .catch((err) => {
                return reject(err);
              });
          } else {
            return resolve();
          }
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  /**
   * Create the folder that stores the schedules. It is based on the player name, the soc id and the user id.
   */
  createScheduleSavePath() {
    // Create promise array for promise all
    const promises = [];
    promises.push(this.createDir("./temp/" + this.userData.socId));
    promises.push(this.createDir(this.userPath));
    promises.push(this.createDir(this.userPath + "compilingProject"));
    promises.push(this.createDir(this.userPath + "compiled"));
    promises.push(this.createDir(this.compilingPath));

    return new Promise((resolve, reject) => {
      //TODO: MAKE A EXPLORER FUNCTION THAT TAKE AN ARRAY OF DIR TO CREATE AND MAKE A BETTER RETURN IF 500 ALREADY EXIST
      Promise.all(promises)
        .then(() => {
          return resolve();
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  /**
   * Extract a project from the given path
   * @param { String } path
   * @returns Promise
   */
  extractProject(path) {
    return new Promise((resolve, reject) => {
      const projectExtractPath = this.getProjectPath(ft.getFileNameFromPath(path));

      this.createDir(projectExtractPath)
        .then(() => {
          ft.extract(path, projectExtractPath)
            .then(() => {
              return resolve();
            })
            .catch((err) => {
              return reject(err);
            });
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  /**
   * Extract all the project being store in the schedule to create the scheduleFile.
   * Filter the projects so that we don't have two alike in the folder (schedule can have same project but not same play time)
   */
  extractAllProjects() {
    return new Promise((resolve, reject) => {
      //TODO: Make a promise of this to be sure that all files are decompress before doing anything
      // Keep all project path_dl
      const allProjects = this.scheduleManager.schedulesReader.map((reader) => {
        // Get all url path to project
        let path = reader.schedule.projectData.path_dl;
        // Remove parts containing ip + mediacenter and rewrite ./mediacenter/
        path = path.replace(store.state.config.url.server + "/mediacenter/", "./mediacenter/");

        return path;
      });

      // Remove duplicates from allProjects
      const projectsPath = allProjects.filter((item, pos) => {
        return allProjects.indexOf(item) == pos;
      });

      // Create promise array for promise all
      const promises = projectsPath.map((path) => this.extractProject(path));

      Promise.all(promises)
        .then(() => {
          try {
            explore
              .post("/io/write/", {
                currPath: this.previewPath + "scheduleManager.json",
                data: this.scheduleManager,
              })
              .then(() => {
                return resolve();
              })
              .catch((err) => {
                return reject(err);
              });
          } catch (err) {
            return reject(err);
          }
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  /**
   * Give the project name without his extension.
   * @param {String} projectPath The path to the project zip
   */
  getProjectNameFromPath(projectPath) {
    let projectNameWithExt = projectPath.split("/");
    projectNameWithExt = projectNameWithExt[projectNameWithExt.length - 1];
    projectNameWithExt = projectNameWithExt.split(".");
    projectNameWithExt.pop();
    const projectName = projectNameWithExt.join("");
    return projectName;
  }

  /**
   * Create the project path based on where the projects will be stored + the projectName.
   * @param {String} projectName The project name
   */
  getProjectPath(projectName) {
    if (this.preview) {
      return this.previewPath + "projects/" + projectName;
    } else return this.projectsPath + projectName;
  }

  /**
   * Main method, it execute the whole process.
   */
  make() {
    return new Promise((resolve, reject) => {
      if (this.preview) {
        // Delete dir before new preview to prevent keeping other projects
        ft.remove(this.previewPath).finally(() => {
          this.createDir(this.previewPath)
            .then(() => {
              this.createDir(this.previewPath + "projects/")
                .then(() => {
                  this.extractAllProjects()
                    .then(() => {
                      return resolve();
                    })
                    .catch((err) => {
                      return reject(err);
                    });
                })
                .catch((err) => {
                  return reject(err);
                });
            })
            .catch((err) => {
              return reject(err);
            });
        });
      } else {
        const jsonSchedule = JSON.stringify(this.scheduleManager);

        db.post("/MQTTMessage/sendMessage/", {
          message: jsonSchedule,
          license: "dmcware/" + this.playerLicense,
        })
          .then(() => {
            return resolve();
          })
          .catch((err) => {
            return reject(err);
          });
      }
    });
  }
}
